'use strict';

const highlightLocationPrediction =  function () {
  function getMatchingTerm(terms, matchedSubstring) {
    var length = terms.length;
    var substringOffset = matchedSubstring.offset;
    var iter;
    var matchingTerm;
    var currentTerm;
    var currentTermLength;
    var currentTermOffset;

    for (iter = 0; iter < length; iter++) {
      currentTerm = terms[iter];
      currentTermOffset = currentTerm.offset;
      currentTermLength = currentTerm.value.length;

      if (currentTermOffset <= substringOffset && (currentTermLength + currentTermOffset) > substringOffset) {
        matchingTerm = currentTerm;
        break;
      }
    }

    return matchingTerm;
  }

  function wrapMatchingTerm(matchedTerm, matchedSubstring) {
    var term = matchedTerm.value;
    var offset = matchedSubstring.offset - matchedTerm.offset;
    var length = Math.min(term.length, matchedSubstring.length);
    var beforeSubstring = term.substring(0, offset);
    var afterSubstring = term.substring(offset + length, term.length);
    var substringHtml = '<strong>' + term.substring(offset, offset + length) + '</strong>';

    return '<span class="AutocompletePredictions-query">' + beforeSubstring + substringHtml + afterSubstring + '</span>';
  }

  function getResultHtml(matchedTermHtml, matchingTerm, prediction) {
    var description = prediction.description;
    var offset = matchingTerm.offset;
    var length = matchingTerm.value.length;
    var beforeMatchedTerm = description.substring(0, offset);
    var afterMatchedTerm = description.substring(offset + length, description.length);

    return beforeMatchedTerm + matchedTermHtml + afterMatchedTerm;
  }

  function filter(prediction) {
    try {
      var matchedSubstring = prediction['matched_substrings'][0];
      var matchingTerm = getMatchingTerm(prediction.terms, matchedSubstring);
      var matchingSubstringHtml = wrapMatchingTerm(matchingTerm, matchedSubstring);
      return getResultHtml(matchingSubstringHtml, matchingTerm, prediction);
    } catch (e) {
      return;
    }

  }

  return filter;
};

export default highlightLocationPrediction;



// WEBPACK FOOTER //
// ./app/src/common/location_search/location_prediction.filter.js